import useApi from '../../../services/useApi'
import useFilters from '../../../hook/useFilters'
import moment from 'moment'
import {useState} from 'react'

const useGetSalesRepTypeReport = () => {
  const Api = useApi()
  const [dateRange] = useState(() => JSON.parse(localStorage.getItem('selectedDateRange') || '{}'))

  const initialFilters = {
    start_date: dateRange?.startDate ?? moment().subtract(3, 'months').format('YYYY-MM-DD'),
    end_date: dateRange?.endDate ?? moment().format('YYYY-MM-DD'),
    sort_by: 'total_discount/-1',
  }

  const {filters, onSortingChange, onDateChange} = useFilters(initialFilters, {sortType: 'number'})

  const {data: response, isFetching} = Api.useGetQuery(
    '/analytics/order-discount/report/sales-rep-type',
    {
      queryId: 'discount-sales-rep-type-report',
      filters,
    }
  )

  return {
    reportData: response?.data || [],
    isLoading: isFetching,
    filters,
    onSortingChange,
    onDateChange,
  }
}

export default useGetSalesRepTypeReport
